import type { Resource } from '../../';
export const giftcard_cart_from: Resource = {"default":"From"};
